import React, { useState } from "react";
import { Collapse } from "reactstrap";

const BankvoleFrequentQuestio = ({ displaySeeMore = true }) => {
  const [current, setCurrent] = useState("");
  const [displayMore, setDisplayMore] = useState(false);

  const toggle = (id) => setCurrent(current === id ? "" : id);

  return (
    <div className="frequent-question">
      <h1>Frequently Asked Questions</h1>

      {/* FIRST 10 (visible initially) */}
      <div className={current === "1" ? "question-box2 d-flex justify-content-between align-items-center" : "question-box d-flex justify-content-between align-items-center"}>
        <div className="text m-3">What services does Bankvole offer?</div>
        <button className="btn border-0 text m-3" onClick={() => toggle("1")}>{current === "1" ? "-" : "+"}</button>
      </div>
      <Collapse isOpen={current === "1"}>
        <div className="m-3 answer">
          <p>Bankvole is a modern banking platform that offers various savings plans designed to help grow your money efficiently and make informed financial decisions.</p>
        </div>
      </Collapse>

      <div className={current === "2" ? "question-box2 d-flex justify-content-between align-items-center" : "question-box d-flex justify-content-between align-items-center"}>
        <div className="text m-3">How can I open an account with Bankvole?</div>
        <button className="btn border-0 text m-3" onClick={() => toggle("2")}>{current === "2" ? "-" : "+"}</button>
      </div>
      <Collapse isOpen={current === "2"}>
        <div className="m-3 answer">
          <p>To open an account with Bankvole, follow these steps:</p>
          <ul className="ul-style">
            <li >Download the Bankvole App
              <ul className="ul-style">
                <li >Visit the Google Play Store (for Android users) or Apple App Store (for iOS users) and search for Bankvole. Download and install the app.</li>
              </ul>
            </li>
            <li >Sign Up
              <ul className="ul-style">
                <li >Open the app and click on Sign Up</li>
              </ul>
            </li>
            <li >Verify Your BVN
              <ul className="ul-style">
                <li >Enter your Bank Verification Number (BVN).</li>
                <li >You will receive a One-Time Password (OTP) sent to your registered phone number by NIBSS (Nigeria Inter-Bank Settlement System).</li>
                <li >Enter the OTP in the app to verify your BVN successfully.</li>
              </ul>
            </li>
            <li >Provide Your Details
              <ul className="ul-style">
                <li >Fill in basic personal details, such as occupation etc</li>
              </ul>
            </li>
            <li >Add Bank Account for Payouts
              <ul className="ul-style">
                <li >Provide your bank account details where your matured investments or interest earnings will be credited.</li>
              </ul>
            </li>
            <li >Set Up a Secure PIN
              <ul className="ul-style">
                <li >Choose a 4-digit PIN to enable secure transactions on the app.</li>
              </ul>
            </li>
            <li >Start Using Bankvole
              <ul className="ul-style">
                <li >Once all steps are complete, you can begin depositing funds, creating savings plans, and managing investments.</li>
              </ul>
            </li>
          </ul>
        </div>
      </Collapse>

      <div className={current === "3" ? "question-box2 d-flex justify-content-between align-items-center" : "question-box d-flex justify-content-between align-items-center"}>
        <div className="text m-3">Is there a minimum investment amount?</div>
        <button className="btn border-0 text m-3" onClick={() => toggle("3")}>{current === "3" ? "-" : "+"}</button>
      </div>
      <Collapse isOpen={current === "3"}>
        <div className="m-3 answer">
          <p>Yes, minimum amount of #50,000</p>
        </div>
      </Collapse>

      <div className={current === "4" ? "question-box2 d-flex justify-content-between align-items-center" : "question-box d-flex justify-content-between align-items-center"}>
        <div className="text m-3">What savings plans does Bankvole offer?</div>
        <button className="btn border-0 text m-3" onClick={() => toggle("4")}>{current === "4" ? "-" : "+"}</button>
      </div>
      <Collapse isOpen={current === "4"}>
        <div className="m-3 answer">
          <p>Bankvole offers a variety of savings plans tailored to meet your financial goals:</p>
          <ul className="ul-style">
            <li >Earn Plan: Start saving with a minimum deposit of ₦50,000.</li>
            <li >Build Plan: Requires a minimum deposit of ₦100,000, ideal for steady growth.</li>
            <li >Flex Plan: Enjoy flexibility with a minimum deposit of ₦500,000.</li>
            <li >Keep Plan: Designed for long-term savings with a minimum deposit of ₦500,000.</li>
          </ul>
        </div>
      </Collapse>

      <div className={current === "5" ? "question-box2 d-flex justify-content-between align-items-center" : "question-box d-flex justify-content-between align-items-center"}>
        <div className="text m-3">How does Bankvole ensure the security of my personal information?</div>
        <button className="btn border-0 text m-3" onClick={() => toggle("5")}>{current === "5" ? "-" : "+"}</button>
      </div>
      <Collapse isOpen={current === "5"}>
        <div className="m-3 answer">
          <p>Bankvole prioritizes your security by using advanced encryption, secure authentication protocols, and strict compliance with data protection regulations. Your information is safeguarded against unauthorized access, ensuring your privacy and peace of mind.</p>
        </div>
      </Collapse>

      <div className={current === "6" ? "question-box2 d-flex justify-content-between align-items-center" : "question-box d-flex justify-content-between align-items-center"}>
        <div className="text m-3">Can I access my Bankvole account from multiple devices?</div>
        <button className="btn border-0 text m-3" onClick={() => toggle("6")}>{current === "6" ? "-" : "+"}</button>
      </div>
      <Collapse isOpen={current === "6"}>
        <div className="m-3 answer">
          <p>Yes, you can access your Bankvole account from multiple devices. Simply log in using your registered credentials and verify your identity with an OTP or Face ID for added security. This ensures safe and seamless access across all your devices.</p>
        </div>
      </Collapse>

      <div className={current === "7" ? "question-box2 d-flex justify-content-between align-items-center" : "question-box d-flex justify-content-between align-items-center"}>
        <div className="text m-3">What is the plan stimulator for?</div>
        <button className="btn border-0 text m-3" onClick={() => toggle("7")}>{current === "7" ? "-" : "+"}</button>
      </div>
      <Collapse isOpen={current === "7"}>
        <div className="m-3 answer">
          <p>The Plan Simulator on Bankvole is a tool designed to help you visualize and plan your savings and investment goals. It allows you to:</p>
          <ul className="ul-style">
            <li >Estimate Returns: Enter your desired savings amount, preferred plan, and duration to see the potential returns on your investment.</li>
            <li >Compare Plans: Evaluate different savings plans (Earn, Build, Flex, and Keep) to choose the one that best aligns with your financial goals.</li>
            <li >Set Realistic Goals: Adjust inputs such as deposit amounts and timelines to match your budget and desired outcomes.</li>
          </ul>
        </div>
      </Collapse>

      <div className={current === "8" ? "question-box2 d-flex justify-content-between align-items-center" : "question-box d-flex justify-content-between align-items-center"}>
        <div className="text m-3">Can I open 2 or more accounts with Bankvole?</div>
        <button className="btn border-0 text m-3" onClick={() => toggle("8")}>{current === "8" ? "-" : "+"}</button>
      </div>
      <Collapse isOpen={current === "8"}>
        <div className="m-3 answer">
          <p>No, Bankvole allows you to open only one account per user to ensure secure and streamlined management of your investments and savings. If you need to manage multiple savings plans, you can do so within your single account.</p>
        </div>
      </Collapse>

      <div className={current === "9" ? "question-box2 d-flex justify-content-between align-items-center" : "question-box d-flex justify-content-between align-items-center"}>
        <div className="text m-3">Can I withdraw my funds before the maturity date?</div>
        <button className="btn border-0 text m-3" onClick={() => toggle("9")}>{current === "9" ? "-" : "+"}</button>
      </div>
      <Collapse isOpen={current === "9"}>
        <div className="m-3 answer">
          <p>No, Bankvole does not allow early withdrawals from savings plans before the maturity date. This is to ensure that your investments grow as planned and yield the intended returns.</p>
        </div>
      </Collapse>

      <div className={current === "10" ? "question-box2 d-flex justify-content-between align-items-center" : "question-box d-flex justify-content-between align-items-center"}>
        <div className="text m-3">How can I set an autosave on my Bankvole app?</div>
        <button className="btn border-0 text m-3" onClick={() => toggle("10")}>{current === "10" ? "-" : "+"}</button>
      </div>
      <Collapse isOpen={current === "10"}>
        <div className="m-3 answer">
          <p>The sweep frequency helps you automatically save your funds to your plan either daily, weekly or monthly. You can link your debit card to enable you to save directly from your Bank account or your wallet at a set date.</p>
        </div>
      </Collapse>

      {/* SEE MORE: remaining FAQs (revealed after see more) */}
      <Collapse isOpen={displayMore}>
        <div className={current === "11" ? "question-box2 d-flex justify-content-between align-items-center" : "question-box d-flex justify-content-between align-items-center"}>
          <div className="text m-3">Can I keep money in the Bankvole app?</div>
          <button className="btn border-0 text m-3" onClick={() => toggle("11")}>{current === "11" ? "-" : "+"}</button>
        </div>
        <Collapse isOpen={current === "11"}>
          <div className="m-3 answer">
            <p>Yes, you can keep money in your Bankvole account without investing. The app allows you to hold funds in your account for future investments or use them for other financial goals, while still benefiting from the secure and easy-to-use platform.</p>
            <p><strong>N.B:</strong> You can only withdraw after 30days while you earn 10% interest on your wallet!</p>
          </div>
        </Collapse>

        <div className={current === "12" ? "question-box2 d-flex justify-content-between align-items-center" : "question-box d-flex justify-content-between align-items-center"}>
          <div className="text m-3">What should I do if I forget my pin?</div>
          <button className="btn border-0 text m-3" onClick={() => toggle("12")}>{current === "12" ? "-" : "+"}</button>
        </div>
        <Collapse isOpen={current === "12"}>
          <div className="m-3 answer">
            <p>Please contact us bankvole@checkoff.finance or 234(0)7074806182 on whatsapp to enable us to assist further.</p>
          </div>
        </Collapse>

        <div className={current === "13" ? "question-box2 d-flex justify-content-between align-items-center" : "question-box d-flex justify-content-between align-items-center"}>
          <div className="text m-3">How can I change my pin?</div>
          <button className="btn border-0 text m-3" onClick={() => toggle("13")}>{current === "13" ? "-" : "+"}</button>
        </div>
        <Collapse isOpen={current === "13"}>
          <div className="m-3 answer">
            <p>If you suspect that your PIN has been compromised, follow these steps to change it:</p>
            <ul className="ul-style">
              <li >Log in to your Bankvole account.</li>
              <li >Go to Toggle button</li>
              <li >Select Change PIN.</li>
              <li >Enter your current PIN for verification, then create a new PIN.</li>
              <li >Confirm your new PIN to complete the change.</li>
            </ul>
            <p>For further assistance please contact us (bankvole@checkoff.finance) or 234(0)7074806182 on whatsapp.</p>
          </div>
        </Collapse>

        <div className={current === "14" ? "question-box2 d-flex justify-content-between align-items-center" : "question-box d-flex justify-content-between align-items-center"}>
          <div className="text m-3">Are there any limits on transactions with Bankvole?</div>
          <button className="btn border-0 text m-3" onClick={() => toggle("14")}>{current === "14" ? "-" : "+"}</button>
        </div>
        <Collapse isOpen={current === "14"}>
          <div className="m-3 answer">
            <p>No, there are no limits on transactions with Bankvole. You can make deposits, withdrawals, and transfers without restrictions, giving you full flexibility in managing your funds.</p>
          </div>
        </Collapse>

        <div className={current === "15" ? "question-box2 d-flex justify-content-between align-items-center" : "question-box d-flex justify-content-between align-items-center"}>
          <div className="text m-3">How can I contact customer support for Bankvole?</div>
          <button className="btn border-0 text m-3" onClick={() => toggle("15")}>{current === "15" ? "-" : "+"}</button>
        </div>
        <Collapse isOpen={current === "15"}>
          <div className="m-3 answer">
            <p>Bankvole offers customer support through email bankvole@checkoff.finance, and 234(0)7074806182 on whatsapp or a dedicated FAQ section where you can find answers to common questions. To reach us please click on the toggle menu and select contact us.</p>
          </div>
        </Collapse>

        <div className={current === "16" ? "question-box2 d-flex justify-content-between align-items-center" : "question-box d-flex justify-content-between align-items-center"}>
          <div className="text m-3">Does Bankvole allow me link my debit card?</div>
          <button className="btn border-0 text m-3" onClick={() => toggle("16")}>{current === "16" ? "-" : "+"}</button>
        </div>
        <Collapse isOpen={current === "16"}>
          <div className="m-3 answer">
            <p>Yes, Bankvole allows you to link your debit card to your account for easy deposits and withdrawals. This makes it convenient to fund your savings plans and manage your finances directly from your linked card.</p>
          </div>
        </Collapse>

        <div className={current === "17" ? "question-box2 d-flex justify-content-between align-items-center" : "question-box d-flex justify-content-between align-items-center"}>
          <div className="text m-3">What are the benefits of using Bankvole over traditional banks?</div>
          <button className="btn border-0 text m-3" onClick={() => toggle("17")}>{current === "17" ? "-" : "+"}</button>
        </div>
        <Collapse isOpen={current === "17"}>
          <div className="m-3 answer">
            <p>Bankvole offers higher returns on savings, flexible investment options, and a user-friendly app for easy account management. Unlike traditional banks, it provides tailored plans and seamless digital access without the need for in-branch visits.</p>
          </div>
        </Collapse>

        <div className={current === "18" ? "question-box2 d-flex justify-content-between align-items-center" : "question-box d-flex justify-content-between align-items-center"}>
          <div className="text m-3">Can I access my account anytime?</div>
          <button className="btn border-0 text m-3" onClick={() => toggle("18")}>{current === "18" ? "-" : "+"}</button>
        </div>
        <Collapse isOpen={current === "18"}>
          <div className="m-3 answer">
            <p>Yes, you can access your Bankvole account anytime, 24/7, through the app. Enjoy full control over your savings and investments whenever you need it, from anywhere.</p>
          </div>
        </Collapse>

        <div className={current === "19" ? "question-box2 d-flex justify-content-between align-items-center" : "question-box d-flex justify-content-between align-items-center"}>
          <div className="text m-3">How can I link my Debit card with Bankvole?</div>
          <button className="btn border-0 text m-3" onClick={() => toggle("19")}>{current === "19" ? "-" : "+"}</button>
        </div>
        <Collapse isOpen={current === "19"}>
          <div className="m-3 answer">
            <p>1. Click on the toggle menu in the Bankvole app.</p>
            <p>2. Select Funding Method.</p>
            <p>3. Click on Link Card and enter your debit card information.</p>
            <p>4. Click Next and input your PIN.</p>
            <p>5. An OTP will be sent to the number registered on your debit card for authorization.</p>
            <p>Once authorized, your debit card will be linked to your Bankvole account.</p>
          </div>
        </Collapse>

        <div className={current === "20" ? "question-box2 d-flex justify-content-between align-items-center" : "question-box d-flex justify-content-between align-items-center"}>
          <div className="text m-3">Can I change my linked bank account?</div>
          <button className="btn border-0 text m-3" onClick={() => toggle("20")}>{current === "20" ? "-" : "+"}</button>
        </div>
        <Collapse isOpen={current === "20"}>
          <div className="m-3 answer">
            <p>Yes, to change your linked bank account, please contact us at bankvole@checkoff.finance or 234(0)7074806182 on whatsapp. Our support team will assist you with the process.</p>
          </div>
        </Collapse>

        <div className={current === "21" ? "question-box2 d-flex justify-content-between align-items-center" : "question-box d-flex justify-content-between align-items-center"}>
          <div className="text m-3">How can I withdraw my funds?</div>
          <button className="btn border-0 text m-3" onClick={() => toggle("21")}>{current === "21" ? "-" : "+"}</button>
        </div>
        <Collapse isOpen={current === "21"}>
          <div className="m-3 answer">
            <p>To withdraw your funds from Bankvole:</p>
            <ul className="ul-style">
              <li >Open the Bankvole app.</li>
              <li >Go to the Withdraw section from the main menu.</li>
              <li >Input the amount you wish to withdraw.</li>
              <li >Choose the linked bank account where you want the funds to be transferred.</li>
              <li >Confirm the withdrawal and complete the process.</li>
            </ul>
          </div>
        </Collapse>

        <div className={current === "22" ? "question-box2 d-flex justify-content-between align-items-center" : "question-box d-flex justify-content-between align-items-center"}>
          <div className="text m-3">Can I Refer Someone?</div>
          <button className="btn border-0 text m-3" onClick={() => toggle("22")}>{current === "22" ? "-" : "+"}</button>
        </div>
        <Collapse isOpen={current === "22"}>
          <div className="m-3 answer">
            <p>Yes, you can refer someone to Bankvole. Simply use the referral feature within the app to share your unique referral code with friends or family. You may also earn rewards or benefits based on successful referrals, depending on current promotions.</p>
          </div>
        </Collapse>

        <div className={current === "23" ? "question-box2 d-flex justify-content-between align-items-center" : "question-box d-flex justify-content-between align-items-center"}>
          <div className="text m-3">How Can I Get My Referral Link?</div>
          <button className="btn border-0 text m-3" onClick={() => toggle("23")}>{current === "23" ? "-" : "+"}</button>
        </div>
        <Collapse isOpen={current === "23"}>
          <div className="m-3 answer">
            <p>1. Open the Bankvole app.</p>
            <p>2. Click on the toggle menu.</p>
            <p>3. Select Refer a Friend.</p>
            <p>4. Copy your referral code or click on Share Referral Code to send it directly to others.</p>
            <p>You can now share your referral code and earn rewards when someone signs up using it.</p>
          </div>
        </Collapse>

        <div className={current === "24" ? "question-box2 d-flex justify-content-between align-items-center" : "question-box d-flex justify-content-between align-items-center"}>
          <div className="text m-3">How Do I Sign In?</div>
          <button className="btn border-0 text m-3" onClick={() => toggle("24")}>{current === "24" ? "-" : "+"}</button>
        </div>
        <Collapse isOpen={current === "24"}>
          <div className="m-3 answer">
            <p>To sign in:</p>
            <ul className="ul-style">
              <li >Open the Bankvole app.</li>
              <li >Input your mobile number.</li>
              <li >You will receive an OTP sent from Fadeke at Bankvole.</li>
              <li >Enter the OTP to complete your sign-in process.</li>
            </ul>
            <p>mailto:bankvole@checkoff.finance</p>
          </div>
        </Collapse>

        <div className={current === "25" ? "question-box2 d-flex justify-content-between align-items-center" : "question-box d-flex justify-content-between align-items-center"}>
          <div className="text m-3">What Are My Sign-In Options?</div>
          <button className="btn border-0 text m-3" onClick={() => toggle("25")}>{current === "25" ? "-" : "+"}</button>
        </div>
        <Collapse isOpen={current === "25"}>
          <div className="m-3 answer">
            <p>Bankvole offers the following sign-in options:</p>
            <ul className="ul-style">
              <li >Email OTP: Sign in by entering a One-Time Password (OTP) sent to your email.</li>
              <li >Stay Signed In: Choose this option to remain logged in for convenience.</li>
              <li >Biometrics: Use your fingerprint or facial recognition for quick and secure sign-in.</li>
            </ul>
          </div>
        </Collapse>

        <div className={current === "26" ? "question-box2 d-flex justify-content-between align-items-center" : "question-box d-flex justify-content-between align-items-center"}>
          <div className="text m-3">How Do I Log Out?</div>
          <button className="btn border-0 text m-3" onClick={() => toggle("26")}>{current === "26" ? "-" : "+"}</button>
        </div>
        <Collapse isOpen={current === "26"}>
          <div className="m-3 answer">
            <p>To log out of your Bankvole account:</p>
            <ul className="ul-style">
              <li >Open the Bankvole app.</li>
              <li >Click on the toggle menu.</li>
              <li >Scroll down and select Log Out.</li>
            </ul>
            <p>This will log you out of your account for security purposes.</p>
          </div>
        </Collapse>

        <div className={current === "27" ? "question-box2 d-flex justify-content-between align-items-center" : "question-box d-flex justify-content-between align-items-center"}>
          <div className="text m-3">How Can I Fund My Account?</div>
          <button className="btn border-0 text m-3" onClick={() => toggle("27")}>{current === "27" ? "-" : "+"}</button>
        </div>
        <Collapse isOpen={current === "27"}>
          <div className="m-3 answer">
            <p>To fund your Bankvole account:</p>
            <ul className="ul-style">
              <li >Open the Bankvole app.</li>
              <li >On the landing page, click on Fund Wallet.</li>
              <li >Select your preferred funding method:
                <ul className="ul-style">
                  <li >Bank Transfer: This takes you to the wallet account number created for you. Simply transfer the amount to this account, and your wallet will be funded.</li>
                  <li >Card: Select an existing card or link a new card, input the amount, and confirm.</li>
                </ul>
              </li>
              <li >Once completed, your wallet will be funded, and you can start using your account.</li>
            </ul>
          </div>
        </Collapse>

        <div className={current === "28" ? "question-box2 d-flex justify-content-between align-items-center" : "question-box d-flex justify-content-between align-items-center"}>
          <div className="text m-3">How Do I Create a Savings Plan?</div>
          <button className="btn border-0 text m-3" onClick={() => toggle("28")}>{current === "28" ? "-" : "+"}</button>
        </div>
        <Collapse isOpen={current === "28"}>
          <div className="m-3 answer">
            <p>To create a savings plan:</p>
            <ul className="ul-style">
              <li >On the home page, swipe right on your wallet balance until you see Add New Savings Plan.</li>
              <li >Choose the savings plan you want after reviewing its features.</li>
              <li >Follow the on-screen prompts to complete the setup.</li>
              <li >Alternatively, you can create a savings plan by clicking on the plus button on the home page and selecting your preferred plan.</li>
            </ul>
          </div>
        </Collapse>

        <div className={current === "29" ? "question-box2 d-flex justify-content-between align-items-center" : "question-box d-flex justify-content-between align-items-center"}>
          <div className="text m-3">What Does Plan Name Mean?</div>
          <button className="btn border-0 text m-3" onClick={() => toggle("29")}>{current === "29" ? "-" : "+"}</button>
        </div>
        <Collapse isOpen={current === "29"}>
          <div className="m-3 answer">
            <p>The Plan Name refers to the specific name or label you give to your savings plan. It helps you easily identify and distinguish between different plans you may have, such as "Emergency Fund," "Vacation Fund," or "Retirement Savings." This name is for your reference and organization within the app.</p>
          </div>
        </Collapse>

        <div className={current === "30" ? "question-box2 d-flex justify-content-between align-items-center" : "question-box d-flex justify-content-between align-items-center"}>
          <div className="text m-3">What Does Tenor Mean?</div>
          <button className="btn border-0 text m-3" onClick={() => toggle("30")}>{current === "30" ? "-" : "+"}</button>
        </div>
        <Collapse isOpen={current === "30"}>
          <div className="m-3 answer">
            <p>Tenor refers to the duration or length of time for which your savings plan or investment will last. It is the period from when you start the plan until the maturity or completion date. For example, a tenor of 6 months means your investment or savings plan will last for 6 months.</p>
          </div>
        </Collapse>

        <div className={current === "31" ? "question-box2 d-flex justify-content-between align-items-center" : "question-box d-flex justify-content-between align-items-center"}>
          <div className="text m-3">What Does Sweep Frequency Mean?</div>
          <button className="btn border-0 text m-3" onClick={() => toggle("31")}>{current === "31" ? "-" : "+"}</button>
        </div>
        <Collapse isOpen={current === "31"}>
          <div className="m-3 answer">
            <p>Sweep Frequency refers to the interval at which funds are automatically transferred into your savings plan. For example, if the sweep frequency is set to "weekly," a set amount will be deducted from your linked account and deposited into your savings plan every week. This helps you regularly contribute to your plan without manual intervention.</p>
          </div>
        </Collapse>

        <div className={current === "32" ? "question-box2 d-flex justify-content-between align-items-center" : "question-box d-flex justify-content-between align-items-center"}>
          <div className="text m-3">What Does Sweep Amount Mean?</div>
          <button className="btn border-0 text m-3" onClick={() => toggle("32")}>{current === "32" ? "-" : "+"}</button>
        </div>
        <Collapse isOpen={current === "32"}>
          <div className="m-3 answer">
            <p>Sweep Amount refers to the specific amount of money that will be automatically transferred from your linked account into your savings plan based on the set sweep frequency. For example, if your sweep amount is set to 5,000 Naira, that amount will be deducted and added to your savings plan every time the sweep occurs.</p>
          </div>
        </Collapse>

        <div className={current === "33" ? "question-box2 d-flex justify-content-between align-items-center" : "question-box d-flex justify-content-between align-items-center"}>
          <div className="text m-3">What Is the Interest Rate I Will Receive?</div>
          <button className="btn border-0 text m-3" onClick={() => toggle("33")}>{current === "33" ? "-" : "+"}</button>
        </div>
        <Collapse isOpen={current === "33"}>
          <div className="m-3 answer">
            <p>Bankvole offers interest rates of up to 21%. However, to get the exact interest rate for the amount you intend to invest, use the Plan Simulator. You will also be able to see the applicable interest rate while creating your savings plan.</p>
          </div>
        </Collapse>

        <div className={current === "34" ? "question-box2 d-flex justify-content-between align-items-center" : "question-box d-flex justify-content-between align-items-center"}>
          <div className="text m-3">Where Will My Interest and Matured Investment Be Credited?</div>
          <button className="btn border-0 text m-3" onClick={() => toggle("34")}>{current === "34" ? "-" : "+"}</button>
        </div>
        <Collapse isOpen={current === "34"}>
          <div className="m-3 answer">
            <p>Your interest and matured investment will be credited to your wallet within the Bankvole app. From there, you can withdraw the funds to your pre-added bank account number.</p>
          </div>
        </Collapse>

      </Collapse>

      {/* See more button (shows rest) */}
      <div className="text-center w-25 m-auto mt-5 see-more">
        {displayMore ? (
          <button className="btn btn-primary shadow-none" onClick={() => setDisplayMore(false)}>see less -</button>
        ) : (
          <button className="btn btn-primary shadow-none" onClick={() => setDisplayMore(true)}>see more +</button>
        )}
      </div>
    </div>
  );
};

export default BankvoleFrequentQuestio;
